/* eslint-disable eqeqeq */
import { fExecuteAPI } from "../../Server/Apis";
import {
  RpDesign_binsearch_GETROW,
  stockAdjustment_stockAdjustmentAttributes_GETROW,
} from "../../Server/ApiV2";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  GetCostUpdate,
  Get_TransItemStockUOM,
} from "../../Utility/Utilitys";

import {
  Set_WmsStockAdjustment_HeadObject_Set,
  Set_StockAdjustment_HeadObject_A_VocNo,
} from "./SliceWmsStockAdjustment";

import { vRdxUserInfo, StockAdjustment } from "../../Redux/roStore";
import moment from "moment";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

// const { tax1, tax2 } = vRdxtax();
// const vRdxUserInfoObj = vRdxUserInfo();
// const { HeadObject } = StockAdjustment();

export const ErrorMsg = {
  A_VocTyp: "",
  A_VocTypName: "",
  A_VocNo: "",
  A_PostDt: "", // dd/MM/yyyy
  A_Reason: "",
  A_Loc: "",
  A_LocName: "",
  A_Narr: "",
  A_DocStat: "",
};
export const ErrorMsgDetail = {
  B_Srno: "", // int
  B_AdjType: "",
  B_CardId: "",
  B_Itmcd: "",
  B_ItmName: "",
  B_Batch: "",
  B_MDF: "",
  B_EXD: "",
  B_BinCode: "",
  B_BinName: "",
  B_Qty: "", //Decimal
  B_Unit: "",
  B_UnitName: "",
  B_PackQty: "", //Decimal
  B_UnitCost: "", //Decimal
  B_Value: "", //Decimal
};
export const vHeaderSearchInit = {
  AnyData: "",
  Name: "",
  Code: "",
};

export const sTrnTyp = "WMINV11";

export const xGC_Toggle_Head_BinName_DropDown_Arr = ["Any", "Code", "Name"];
//Narration Search

export const ItemSearchData = [
  "Any",
  "Code",
  "Barcode",
  "Name",
  "RefNo",
  "NameFL",
];

export const locatonSearchData = ["Any", "Code", "Name"];

export const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT", "CANCEL"];

const fKeyStockAdjustment = (event) => {
  // WmsStockAdjustmentContent
  const form = document.getElementById("WmsStockAdjustmentHead");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fKeyStockAdjustmentContent = (event) => {
  // WmsStockAdjustmentContent
  const form = document.getElementById("WmsStockAdjustmentContent");
  const index = [...form].indexOf(event.target);
  if (index < form.length - 1) {
    if (event.key === "Enter") {
      form.elements[index + 1]?.focus();
    }
  }
};

const fValidationHead_Client = (vRdxHead, setErrorMsg) => {
  let iRes = true;

  if (
    vRdxHead.A_VocTyp === "" ||
    vRdxHead.A_VocTyp === null ||
    vRdxHead.A_VocTyp === undefined
  ) {
    fAlertToast("FAILED", "VocTyp should not be empty");
    setErrorMsg((obj) => ({
      ...obj,
      A_VocTyp: "VocTyp should not be empty",
    }));
    iRes = false;
  }

  if (
    vRdxHead.A_VocNo === "" ||
    vRdxHead.A_VocNo === null ||
    vRdxHead.A_VocNo === undefined
  ) {
    fAlertToast("FAILED", "VocNo should not be empty");
    setErrorMsg((obj) => ({ ...obj, A_VocNo: "VocNo should not be empty" }));
    iRes = false;
  }

  // Default format validation
  let iDate = moment(vRdxHead.A_PostDt).format("MM/DD/YYYY");
  if (
    vRdxHead.A_PostDt === "" ||
    vRdxHead.A_PostDt === null ||
    vRdxHead.A_PostDt === undefined ||
    vRdxHead.A_PostDt == "Invalid Date" ||
    new Date(iDate) < new Date("01/01/1990")
  ) {
    fAlertToast("FAILED", "Post date is invalid");
    setErrorMsg((obj) => ({
      ...obj,
      A_PostDt: "Post date is invalid",
    }));
    iRes = false;
  }

  if (
    vRdxHead.A_Loc === "" ||
    vRdxHead.A_Loc === null ||
    vRdxHead.A_Loc === undefined
  ) {
    fAlertToast("FAILED", "Location should not be empty");
    setErrorMsg((obj) => ({ ...obj, A_Loc: "Location should not be empty" }));
    iRes = false;
  }

  if (
    vRdxHead.A_Reason === "" ||
    vRdxHead.A_Reason === null ||
    vRdxHead.A_Reason === undefined
  ) {
    fAlertToast("FAILED", "Reason should not be empty");
    setErrorMsg((obj) => ({
      ...obj,
      A_Reason: "Reason should not be empty",
    }));
    iRes = false;
  }

  return iRes;
};

const fValidationDetail_Client = (sBufferObj, setErrorMsgDetail) => {
  let iRes = true;

  if (
    sBufferObj.B_Srno === "" ||
    sBufferObj.B_Srno === null ||
    sBufferObj.B_Srno === undefined
  ) {
    fAlertToast("FAILED", "Serial number should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Srno: "Serial number should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Itmcd === "" ||
    sBufferObj.B_Itmcd === null ||
    sBufferObj.B_Itmcd === undefined
  ) {
    fAlertToast("FAILED", "Item code should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Itmcd: "Item code should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_ItmName === "" ||
    sBufferObj.B_ItmName === null ||
    sBufferObj.B_ItmName === undefined
  ) {
    fAlertToast("FAILED", "Item name should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_ItmName: "Item name should not be empty",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_Unit === "" ||
    sBufferObj.B_Unit === null ||
    sBufferObj.B_Unit === undefined
  ) {
    fAlertToast("FAILED", "Select unit");
    setErrorMsgDetail((obj) => ({ ...obj, B_Unit: "Select unit" }));
    iRes = false;
  } else if (sBufferObj.B_PackQty === "" || Number(sBufferObj.B_PackQty) <= 0) {
    fAlertToast("FAILED", "Pack quantity should not be zero");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_Unit: "Pack quantity should not be zero",
    }));
    iRes = false;
  }

  if (
    sBufferObj.B_AdjType === "" ||
    sBufferObj.B_AdjType === null ||
    sBufferObj.B_AdjType === undefined
  ) {
    fAlertToast("FAILED", "AdjType should not be empty");
    setErrorMsgDetail((obj) => ({
      ...obj,
      B_AdjType: "AdjType should not be empty",
    }));
    iRes = false;
  }

  if (sBufferObj.B_AdjType === "Adj (+)") {
    if (
      sBufferObj.B_Batch === "" ||
      sBufferObj.B_Batch === null ||
      sBufferObj.B_Batch === undefined
    ) {
      fAlertToast("FAILED", "Batch number should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Batch: "Batch number should not be empty",
      }));
      iRes = false;
    }

    let iDate = moment(sBufferObj.B_MDF).format("MM/DD/YYYY");
    if (
      sBufferObj.B_MDF == "Invalid Date" ||
      new Date(iDate) < new Date("01/01/1990")
    ) {
      fAlertToast("FAILED", "Manufacturing date is invalid");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_MDF: "Date is invalid",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_MDF === "" ||
      sBufferObj.B_MDF === null ||
      sBufferObj.B_MDF === undefined
    ) {
      fAlertToast("FAILED", "Enter valid manufacturing date");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_MDF: "Enter valid manufacturing date",
      }));
      iRes = false;
    }

    let iDateExd = moment(sBufferObj.B_EXD).format("MM/DD/YYYY");
    if (
      sBufferObj.B_EXD == "Invalid Date" ||
      new Date(iDateExd) < new Date("01/01/1990")
    ) {
      fAlertToast("FAILED", "Expiry date is invalid");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_EXD: "Date is invalid",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_EXD === "" ||
      sBufferObj.B_EXD === null ||
      sBufferObj.B_EXD === undefined
    ) {
      fAlertToast("FAILED", "Enter valid expiry date");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_EXD: "Enter valid expiry date",
      }));
      iRes = false;
    }

    if (Date.parse(sBufferObj.B_EXD) < Date.parse(sBufferObj.B_MDF)) {
      fAlertToast(
        "FAILED",
        "Expiry date should be greater than manufacturing date"
      );
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_EXD: "Expiry date should be greater than manufacturing date",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_BinCode === "" ||
      sBufferObj.B_BinCode === null ||
      sBufferObj.B_BinCode === undefined
    ) {
      fAlertToast("FAILED", "Bin code should not be empty");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_BinCode: "Bin code should not be empty",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_Qty === "" ||
      sBufferObj.B_Qty <= 0 ||
      sBufferObj.B_Qty === null ||
      sBufferObj.B_Qty === undefined
    ) {
      fAlertToast("FAILED", "Quantity should be greater than zero");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Qty: "Qty should be positive",
      }));
      iRes = false;
    }
  }

  if (sBufferObj.B_AdjType === "Adj (-)") {
    if (
      sBufferObj.B_BinCode === "" ||
      sBufferObj.B_BinCode === null ||
      sBufferObj.B_BinCode === undefined
    ) {
      fAlertToast("FAILED", "Enter a valid bin");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_BinCode: "Enter valid bin",
      }));
      iRes = false;
    }

    if (
      sBufferObj.B_Qty === "" ||
      sBufferObj.B_Qty >= 0 ||
      sBufferObj.B_Qty === null ||
      sBufferObj.B_Qty === undefined
    ) {
      fAlertToast("FAILED", "Quantity should be negative");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_Qty: "Qty should be negative",
      }));
      iRes = false;
    }
  }

  if (sBufferObj.B_AdjType === "Val (+)") {
    if (
      sBufferObj.B_UnitCost === "" ||
      sBufferObj.B_UnitCost <= 0 ||
      sBufferObj.B_UnitCost === null ||
      sBufferObj.B_UnitCost === undefined
    ) {
      fAlertToast("FAILED", "Unit Rate should be positive");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_UnitCost: "Unit Rate should be positive",
      }));
      iRes = false;
    }
  }
  if (sBufferObj.B_AdjType === "Val (-)") {
    if (
      sBufferObj.B_UnitCost === "" ||
      sBufferObj.B_UnitCost >= 0 ||
      sBufferObj.B_UnitCost === null ||
      sBufferObj.B_UnitCost === undefined
    ) {
      fAlertToast("FAILED", "Unit Rate should be negative");
      setErrorMsgDetail((obj) => ({
        ...obj,
        B_UnitCost: "Unit Rate should be negative",
      }));
      iRes = false;
    }
  }
  return iRes;
};

//GCItemSearch
const GetItemSearch = async (
  xValue,
  xVendor,
  setGridSelectRowData,
  setGridSelectRowArr
) => {
  //openCustomer to call api on open modal if value in any data

  let sItemSearch = {
    v_AnyData: xValue,
    v_ItmCd: "",
    v_ItmName: "",
    v_Barcode: "",
    v_ModelSelectedValue: "",
    v_RefNo1: "",
    v_NameFc: "",
    v_CostPr: "",
    v_RSP: "",
    v_Catalogue: "",
    v_Br: "",
    v_RefNo3: "",
    v_Loc: "",
    v_Vendor: xVendor,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(sItemSearch);
  const vItemSearch = await fExecuteAPI("GRN_ITEMSEARCH_GETROW", FinalObj);
  if (vItemSearch.Status === 200) {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setGridSelectRowArr(vItemSearchArr);
    setGridSelectRowData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.Type.response.data.message
        ? vItemSearch.Type.response.data.message
        : "Error in ItemSearch"
    );
    return [];
  }
};

//TODO FULLSEARCH ,UNITARR ,AND CALCULATION
const fItemCodeDependency = async (
  vItemSearchFull,
  vRdxWmsHead,
  sBufferObj,
  setBufferObj,
  setUnit
) => {
  if (vItemSearchFull.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_Itmcd: vItemSearchFull[0].ItmCd,
      B_ItmName: vItemSearchFull[0].Name2,
      B_Barcode: vItemSearchFull[0].BarCode,
      SuppRefNo1: vItemSearchFull[0].SuppRefNo1,
    }));

    let currentUnitArr = await GetUnitArr(vItemSearchFull[0].ItmCd, setUnit);
    let iUnit = vItemSearchFull[0]?.DefUnit || "";

    if (!iUnit) {
      iUnit = vItemSearchFull[0]?.PurUOM || "";
    }

    let vItemUnitSet = currentUnitArr.find((obj) => {
      return obj.Unit === iUnit;
    });

    if (!vItemUnitSet) {
      iUnit = currentUnitArr[0]?.Unit || "";

      vItemUnitSet = currentUnitArr.find((obj) => {
        return obj.Unit === iUnit;
      });
    }

    await Unit_Onchange_001(
      iUnit,
      vItemUnitSet,
      vItemSearchFull[0].ItmCd,
      setBufferObj
    );

    document.getElementsByName("B_Qty")[0]?.focus();
  } else {
    fAlertToast("FAILED", "Error in Exact Search");
  }
};

export const Unit_Onchange_001 = async (
  xUnit = "",
  xUnitObj = {},
  xItemCode = "",
  setBufferObj
) => {
  const { HeadObject } = StockAdjustment();
  if (!!xUnitObj) {
    setBufferObj((obj) => ({
      ...obj,
      B_Unit: xUnitObj.Unit,
      B_UnitName: xUnitObj.Name1,
      B_PackQty: xUnitObj.PackQty,
    }));
  }

  let currentUnitRateArr = await GetUnitRateArr(
    xItemCode,
    xUnit,
    HeadObject?.A_Loc,
    "" // vRdxWmsHead?.A_RefDocTyp,
  );

  if (currentUnitRateArr.length > 0) {
    setBufferObj((obj) => ({
      ...obj,
      B_UnitCost: currentUnitRateArr[0].CostPr,
      B_Value: currentUnitRateArr[0].LPRate,
    }));
  } else {
    setBufferObj((obj) => ({
      ...obj,
      B_UnitCost: 0,
      B_Value: 0,
    }));
  }
};

const GetSearchItem = async (xData, xType, xA_Loc, setSearchGridData) => {
  let vSeatchVendor = {
    Data: xData,
    Type: xType,
    Loc: xA_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSeatchVendor);
  const vItemSearch = await fExecuteAPI("SEARCHITEM001_GETROW", FinalObj);
  if (vItemSearch.Type == "SUCCESS") {
    let vItemSearchArr = vItemSearch?.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setSearchGridData(vItemSearchArr);
  } else {
    fAlertToast(
      "FAILED",
      vItemSearch.response.data.message
        ? vItemSearch.response.data.message
        : "Error in SearchItem"
    );
  }
};

const fLoad_Grid = async (
  xB_VocNo,
  xB_Srno,
  setDetailGridData,
  xVocTyp,
  setFooterObj
) => {
  const iSIDetail = await GetSIDetail(xB_VocNo, xB_Srno, xVocTyp);
  if (iSIDetail.length > 0) {
    let GridID = iSIDetail?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setDetailGridData(GridID);
    //A_NetAmt
    var B_NetAmt = 0;
    for (let i = 0; i < iSIDetail?.length; i++) {
      B_NetAmt += iSIDetail[i]?.B_NetAmt;
    }
    setFooterObj((obj) => ({
      ...obj,
      F_NetValue: B_NetAmt.toFixed(4),
    }));
  } else {
    setFooterObj((obj) => ({
      ...obj,
      F_NetValue: 0,
    }));
    setDetailGridData([]);
  }
};

//HEAD LOADING API
// Api

//API SALESHISTORY_GETROW
const GetSalesHistory = async (xItmcd, setGridSalesHistoryRowData) => {
  const { HeadObject } = StockAdjustment();
  let vSalesHistoryObj = {
    VocTyp: HeadObject.A_VocTyp,
    VocNo: HeadObject.A_VocNo,
    itmCd: xItmcd,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSalesHistoryObj);

  const vSalesHistory = await fExecuteAPI("WMINV11_history_GETROW", FinalObj);
  if (vSalesHistory?.Type?.toUpperCase() === "SUCCESS") {
    let vSalesHistoryResp = vSalesHistory.ResultSet.map((obj, i) => ({
      ...obj,
      id: i + 1,
      // A_PostDt: moment(obj.A_PostDt).format("DD/MM/YYYY"),
    }));
    setGridSalesHistoryRowData(vSalesHistoryResp);
    return vSalesHistory.ResultSet.length > 0 ? vSalesHistoryResp : [];
  } else {
    fAlertToast("FAILED", vSalesHistory.Message);
    return [];
  }
};

//API GRN_LOCATIONSEARCH_GETROW
const GetLocation = async (
  xAnyData,
  xCode,
  xName,
  UserID,
  setHeaderSearchResultArr,
  setHeaderSearchResultData
) => {
  let vHeaderSearchObj = {
    v_AnyData: xAnyData,
    v_Cd: xCode,
    v_Distri: "Y",
    v_Name: xName,
    v_UserCd: UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vHeaderSearchObj);

  const vHeaderSearch = await fExecuteAPI(
    "GRN_LOCATIONSEARCH_GETROW",
    FinalObj
  );
  if (vHeaderSearch.Status === 200) {
    let GridID = vHeaderSearch.ResultSet?.map((obj, i) => ({
      ...obj,
      id: i + 1,
    }));
    setHeaderSearchResultArr(GridID);
    setHeaderSearchResultData(GridID);
    return GridID;
  } else {
    fAlertToast(
      "FAILED",
      vHeaderSearch.response.data.Status
        ? vHeaderSearch.response.data.Status
        : "Error in loading SrcDoc"
    );
    return [];
  }
};

const GetUnitArr = async (xItemCode, setUnit) => {
  let itemUnitobj = {
    itemCd: xItemCode?.trim(),
  };
  let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

  const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
  if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitInfo.ResultSet.length > 0) {
      setUnit(UnitInfo.ResultSet);
      return UnitInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitInfo.Type.response.data.message
        ? UnitInfo.Type.response.data.message
        : "Error in UnitArr"
    );
    return [];
  }
};

//API  ITEM_LINE_GETROW
const GetItemLineArr = async (xItemCode, xLoc, xParty, setItemLine) => {
  let vItemLineObj = {
    v_ItemCd: xItemCode,
    v_Loc: xLoc,
    v_Vendor: xParty,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemLineObj);

  const ItemLineInfo = await fExecuteAPI("ITEM_LINE_GETROW", FinalObj);
  if (ItemLineInfo.Status === 200) {
    if (ItemLineInfo.ResultSet.length > 0) {
      setItemLine(ItemLineInfo.ResultSet);
      return ItemLineInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      ItemLineInfo.Type.response.data.message
        ? ItemLineInfo.Type.response.data.message
        : "Error in ItemLineArr"
    );
    return [];
  }
};

//API  UNIT_RATE_GETROW
const GetUnitRateArr = async (xItmCd, xUnitId, xLoc, xVocTyp) => {
  let vUnitRateObj = {
    ItmCd: xItmCd,
    UnitId: xUnitId,
    Loc: xLoc,
    Type: xVocTyp,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vUnitRateObj);

  const UnitRateInfo = await fExecuteAPI("WMINV11_UnitRate_GETROW", FinalObj);
  if (UnitRateInfo?.Type?.toUpperCase() === "SUCCESS") {
    if (UnitRateInfo.ResultSet.length > 0) {
      return UnitRateInfo.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      UnitRateInfo.Type.response.data.message
        ? UnitRateInfo.Type.response.data.message
        : "Error in UnitRateArr"
    );
    return [];
  }
};

//API
const GetItemFullSearchArr = async (xItemName, xLoc) => {
  // let vItemFullSearchDataObj = {
  //   v_AnyData: xItemName,
  //   v_TransType: "F",
  //   v_Report: "Y",
  // };
  let vItemFullSearchDataObj = {
    anyData: xItemName,
    transType: "F",
    report: "Y",
    loc: xLoc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemFullSearchDataObj);

  const vItemSearchFull = await fExecuteAPI(
    // "ITEM_SEARCHFULL_GETROW",
    "SEARCHEXACTITEM_GETROW",
    FinalObj
  );
  //status code "" so Success is checked
  if (vItemSearchFull?.Type?.toUpperCase() === "SUCCESS") {
    if (vItemSearchFull.ResultSet.length > 0) {
      return vItemSearchFull.ResultSet;
    } else {
      return [];
    }
  } else {
    fAlertToast(
      "FAILED",
      vItemSearchFull.Type.response.data.message
        ? vItemSearchFull.Type.response.data.message
        : "Error in vItemSearchFullArr"
    );
    return [];
  }
};

//API GETSIDETAILS_GETROW
const GetSIDetail = async (xB_VocNo, xB_Srno, xVocTyp) => {
  let iSIDetailObj = {
    B_VocTyp: !!xVocTyp ? xVocTyp : "",
    B_VocNo: !!xB_VocNo ? xB_VocNo : "",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(iSIDetailObj);

  const iSIDetailResult = await fExecuteAPI(
    "WMINV11_gridLoad_GETROW",
    FinalObj
  );
  if (iSIDetailResult?.Type?.toUpperCase() === "SUCCESS") {
    if (iSIDetailResult.ResultSet.length > 0) {
      return iSIDetailResult.ResultSet;
    } else {
      return [];
    }
  }
};

//API SaveSIHead
const fSaveHead = async (
  xSave,
  setUser_Doc_Arr,
  sUser_Doc_Arr,
  dispatch,
  fNewDetail,
  sBufferObj,
  xDocStatus = "POST"
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  const { HeadObject } = StockAdjustment();
  const iStatus = xSave ? HeadObject.A_DocStat : xDocStatus; //xSave False means Post
  let vSaveSIHeadObj = {
    A_VocTyp: HeadObject.A_VocTyp,
    A_VocNo: HeadObject?.A_VocNo,
    A_VocDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_PostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_RefDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    A_RefNo: HeadObject.A_RefNo,
    A_Type: HeadObject.A_Reason,
    // A_Br: HeadObject.A_Loc,
    A_Loc: HeadObject.A_Loc,
    A_Narr: HeadObject.A_Narr,
    A_NetAmt: 0,
    UserCd: vRdxUserInfoObj.UserID,
    IP: vRdxUserInfoObj.IP,
    A_DocStat: iStatus,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIHeadObj);

  const vSaveSIHead = await fExecuteAPI("WMINV11_saveHead_GETROW", FinalObj);
  if (vSaveSIHead?.Type?.toUpperCase() === "SUCCESS") {
    if (HeadObject.A_VocNo == "0") {
      setUser_Doc_Arr([
        ...sUser_Doc_Arr,
        {
          A_VocTyp: HeadObject.A_VocTyp,
          A_VocNo: vSaveSIHead?.ResultSet[0]?.VocNo,
          SrNo: sUser_Doc_Arr.length + 1,
        },
      ]);
    }

    dispatch(
      Set_StockAdjustment_HeadObject_A_VocNo({
        A_VocNo: xSave ? vSaveSIHead?.ResultSet[0]?.VocNo : HeadObject.A_VocNo,
        A_DocStat: iStatus,
      })
    );

    //approve bool type false
    if (!xSave) {
      fDisplay(
        HeadObject.A_VocTyp,
        xSave ? vSaveSIHead?.ResultSet[0]?.VocNo : HeadObject.A_VocNo,
        dispatch,
        fNewDetail
      );
      setTimeout(() => {
        GetCostUpdate(sTrnTyp, HeadObject?.A_VocTyp, HeadObject?.A_VocNo);
      }, 200);
      fAlertToast("SUCCESS", "Successfully posted");
    } else {
      fSaveDetail(vSaveSIHead.ResultSet[0].VocNo, sBufferObj, fNewDetail);
    }
  } else {
    fAlertToast(
      "FAILED",
      !!vSaveSIHead.response.data.Status
        ? vSaveSIHead?.response?.data?.Status
        : "Fail to Save Head"
    );
  }
};

//API GETSIHEAD_GETROW to gethead
const fDisplay = async (xA_VocTyp, A_VocNo, dispatch, fNewDetail) => {
  const { HeadObject } = StockAdjustment();
  let vSIHeadObj = {
    VocTyp: xA_VocTyp,
    VocNo: A_VocNo,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vSIHeadObj);
  const vSIHead = await fExecuteAPI("WMINV11_fdisplay_GETROW", FinalObj);
  if (vSIHead?.Type?.toUpperCase() === "SUCCESS") {
    dispatch(
      Set_WmsStockAdjustment_HeadObject_Set({
        ...HeadObject,
        A_VocTyp: vSIHead.ResultSet[0].A_VocTyp,
        A_VocTypName: vSIHead.ResultSet[0].VocName,
        A_VocNo: vSIHead.ResultSet[0].A_VocNo,
        A_PostDt: vSIHead.ResultSet[0].A_PostDt,
        A_RefDt: vSIHead.ResultSet[0].A_PostDt,
        A_RefNo: vSIHead.ResultSet[0].A_RefNo,
        A_Reason: vSIHead.ResultSet[0].A_Type,
        A_Loc: vSIHead.ResultSet[0].A_Loc,
        A_Narr: vSIHead.ResultSet[0].A_Narr,
        A_DocStat: vSIHead.ResultSet[0].A_DocStat,
      })
    );

    fNewDetail(vSIHead.ResultSet[0].A_VocNo, vSIHead.ResultSet[0].A_VocTyp);
  }
};

//API SAVESIDETAIL_GETROW
const fSaveDetail = async (xB_VocNo, sBufferObj, fNewDetail) => {
  const { HeadObject } = StockAdjustment();

  let vSaveSIDetailObj = {
    B_VocTyp: HeadObject?.A_VocTyp,
    B_VocNo: xB_VocNo,
    B_Srno: sBufferObj.B_Srno,
    B_AdjTyp: sBufferObj.B_AdjType,
    B_CardID: sBufferObj.B_CardId,
    B_Itmcd: sBufferObj.B_Itmcd,
    B_Qty: sBufferObj.B_Qty,
    B_Unit: sBufferObj.B_Unit,
    B_BaseQty: sBufferObj.B_BaseQty,
    B_UCost: sBufferObj.B_UnitCost,
    B_NetAmt: sBufferObj.B_Value,
    B_RSP: 0,
    B_BatchNo: sBufferObj.B_Batch,
    B_BatchDt:
      moment(sBufferObj.B_MDF).format("MM/DD/YYYY") == "Invalid date"
        ? ""
        : moment(sBufferObj.B_MDF).format("MM/DD/YYYY"),
    B_ExpDt:
      moment(sBufferObj.B_EXD).format("MM/DD/YYYY") == "Invalid date"
        ? ""
        : moment(sBufferObj.B_EXD).format("MM/DD/YYYY"),
    B_BinCd: sBufferObj.B_BinCode,
  };
  console.log(
    "vSaveSIDetailObj",
    vSaveSIDetailObj,
    sBufferObj,
    moment(sBufferObj.B_MDF).format("MM/DD/YYYY")
  );

  let FinalObj = fcheck_null_undefine_replace_empty(vSaveSIDetailObj);
  const vSaveSIDetail = await fExecuteAPI(
    "WMINV11_saveDetail_GETROW",
    FinalObj
  );
  if (vSaveSIDetail?.Type?.toUpperCase() === "SUCCESS") {
    fNewDetail(xB_VocNo, HeadObject?.A_VocTyp);
    fAlertToast("SUCCESS", "Successfully Saved");
  } else if (vSaveSIDetail?.Type?.toUpperCase() === "FAILED") {
    fAlertToast(
      "FAILED",
      vSaveSIDetail.Status ||
        vSaveSIDetail.Message ||
        vSaveSIDetail?.response?.data?.message ||
        vSaveSIDetail.message ||
        "Error in save detail"
    );
  }
};

//API TransTaxType_GETROW
const GetTransTaxType = async (xLoc, xParty, dispatch) => {
  let vTransTaxTypeObj = {
    loc: xLoc,
    party: xParty,
    taxtype: "IN",
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vTransTaxTypeObj);
  const vTransTaxType = await fExecuteAPI("TransTaxType_GETROW", FinalObj);
  if (vTransTaxType?.Type?.toUpperCase() === "SUCCESS") {
    if (vTransTaxType.ResultSet.length > 0) {
      return vTransTaxType.ResultSet[0];
    } else {
      fAlertToast("FAILED", "Default tax object is empty");
      return {};
    }
  } else {
    fAlertToast("FAILED", vTransTaxType?.response?.data?.Status);
    return {};
  }
};

const Get_ToggleDropDown_Load = async (xData, xType, xExact, xLoc) => {
  let vLoaded_Cost_FreightObj = {
    Data: xData,
    Type: xType,
    Loc: xLoc,
    Exact: xExact,
  };
  //Data, Type, Loc, Exact
  let FinalObj = fcheck_null_undefine_replace_empty(vLoaded_Cost_FreightObj);
  const vbinsearchDropdownSearch = await RpDesign_binsearch_GETROW(FinalObj);
  if (vbinsearchDropdownSearch?.status === 200) {
    let GridID = [];
    if (vbinsearchDropdownSearch?.data?.ResultSet?.length > 0) {
      let GridID = vbinsearchDropdownSearch?.data?.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      return GridID;
    } else {
      return GridID;
    }
  } else {
    fAlertToast("FAILED", "Error in binsearch Api");
    return [];
  }
};

//API VALIDATE_HEAD_WMINV03_APPROVE_GETROW
const GetValidateHead_Server = async (dispatch, xApprove) => {
  const { HeadObject } = StockAdjustment();
  const vRdxUserInfoObj = vRdxUserInfo();

  let vValidateHeadApproveObj = {
    xVocTyp: HeadObject.A_VocTyp,
    xVocNo: HeadObject.A_VocNo,
    xPostDt: moment(HeadObject.A_PostDt).format("MM/DD/YYYY"),
    xLoc: HeadObject.A_Loc,
    xUserCd: vRdxUserInfoObj?.UserID,
    xApprove: xApprove,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidateHeadApproveObj);
  const vValidateHeadApprove = await fExecuteAPI(
    "WMINV11_validateHead_GETROW",
    FinalObj
  );
  if (vValidateHeadApprove?.Type?.toUpperCase() === "SUCCESS") {
    return true;
  } else {
    fAlertToast("FAILED", vValidateHeadApprove?.response?.data?.message);

    return false;
  }
};
//API VALIDATIONDETAILINFO_GETROW
const fGetValidationDetail_Server = async (sBufferObj) => {
  const { HeadObject } = StockAdjustment();

  let vResp = true;
  let vValidationDetailInfoObj = {
    xVocTyp: HeadObject.A_VocTyp,
    xVocNo: HeadObject.A_VocNo,
    xSrno: sBufferObj.B_Srno,
    xLoc: HeadObject.A_Loc,
    xAdjTyp: sBufferObj.B_AdjType,
    xCardId: sBufferObj.B_CardId,
    xBinCd: sBufferObj.B_BinCode,
    xItmCd: sBufferObj.B_Itmcd,
    xQty: sBufferObj.B_Qty,
    xUnit: sBufferObj.B_Unit,
    xUnitRate: sBufferObj.B_UnitCost,
    xBinName: sBufferObj.B_BinName,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vValidationDetailInfoObj);
  const vValidationDetailInfo = await fExecuteAPI(
    "WMINV11_validateDetail_GETROW",
    FinalObj
  );
  if (vValidationDetailInfo?.Type?.toUpperCase() == "SUCCESS") {
    vResp = true;
  } else {
    fAlertToast("FAILED", vValidationDetailInfo?.response?.data?.message);
    return (vResp = false);
  }
  return vResp;
};

const GetItemAttributes_Server = async (dispatch, sBufferObj) => {
  const { HeadObject } = StockAdjustment();
  let vItemAttributesPurchaseObj = {
    itmCd: sBufferObj.B_Itmcd?.trim(),
    loc: HeadObject.A_Loc,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemAttributesPurchaseObj);
  const vItemAttributesPurchase = await fExecuteAPI(
    "WMINV11_getItemAttributes_GETROW",
    FinalObj
  );
  if (vItemAttributesPurchase?.Type?.toUpperCase() === "SUCCESS") {
    return vItemAttributesPurchase.ResultSet;
  } else {
    fAlertToast("FAILED", vItemAttributesPurchase?.response?.data?.Status);
    return [];
  }
};
var vheaderArrow = 0;
const fRightClick = (e) => {
  vheaderArrow !== 1 ? (vheaderArrow = vheaderArrow + 1) : (vheaderArrow = 1);

  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

const fLeftClick = (e) => {
  vheaderArrow !== 0 ? (vheaderArrow = vheaderArrow - 1) : (vheaderArrow = 0);
  var headerMainTag = document.getElementById(
    "wms-salese-invoice-id"
  ).childNodes;
  for (let index = 0; index < headerMainTag.length; index++) {
    if (vheaderArrow === index) {
      headerMainTag[index].classList.add("main-wms-sales-invoice-show-sm");
    } else {
      headerMainTag[index].classList.remove("main-wms-sales-invoice-show-sm");
    }
  }
};

//API WMSSI_ITEMSTOCK_GETROW // for viewing ERP & WMS
const GetCurrentStock = async (Loc, ItmCd, Date, setCurrentStock) => {
  let vItemStockObj = {
    Loc: Loc,
    ItmCd: ItmCd,
    Date: moment(Date).format("MM/DD/YYYY"),
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vItemStockObj);

  const vItemStock = await fExecuteAPI("WMINV11_currentStock_GETROW", FinalObj);

  if (vItemStock?.Type?.toUpperCase() === "SUCCESS") {
    let result = vItemStock?.ResultSet[0] || {};
    if (vItemStock.ResultSet.length > 0) {
      setCurrentStock((obj) => ({
        ...obj,
        A_CurrentStockQty: result?.StockQty || 0,
        A_CurrentStockValue: result?.StockValue || 0,
      }));
    } else {
      setCurrentStock((obj) => ({
        ...obj,
        A_CurrentStockQty: 0,
        A_CurrentStockValue: 0,
      }));
    }
  } else {
    fAlertToast("FAILED", vItemStock?.response?.data?.message);
  }
};
export const GetAttributes = async (
  setUser_Doc_Arr,
  setObjectRights,
  setDocLoading,
  setReason
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var vObj = {
    userCode: vRdxUserInfoObj.UserID,
    userGroupCode: vRdxUserInfoObj.UserGroupCode,
  };
  const iAttributes = await stockAdjustment_stockAdjustmentAttributes_GETROW(
    vObj
  );
  if (iAttributes?.status === 200) {
    setUser_Doc_Arr(iAttributes?.data?.ResultSet?.UserDoc);
    setObjectRights(iAttributes?.data?.ResultSet?.Rights);
    setDocLoading(iAttributes?.data?.ResultSet?.DocLoading);
    setReason(iAttributes?.data?.ResultSet?.Reason);
    return iAttributes?.data?.ResultSet;
  } else {
    return [];
  }
};
export const getTransItemStockUOM = async (
  setTransItemStockObj,
  xB_Itmcd,
  xB_Unit,
  xLoc
) => {
  let ApiObj = await Get_TransItemStockUOM(xB_Itmcd, xB_Unit, xLoc);
  if (ApiObj?.length > 0) {
    setTransItemStockObj({
      RPStock: ApiObj[0]?.RPStock,
      MSP: ApiObj[0].MSP,
      CostPr: ApiObj[0].CostPr,
      LPRate: ApiObj[0].LPRate,
    });
  }
};
export {
  // rows,
  // columns,
  fRightClick,
  fLeftClick,
  fKeyStockAdjustment,
  fKeyStockAdjustmentContent,

  // Api
  GetLocation,
  GetUnitArr,
  GetItemLineArr,
  GetUnitRateArr,
  GetItemFullSearchArr,
  GetItemSearch,
  fItemCodeDependency,
  GetSearchItem,
  GetTransTaxType,
  GetCurrentStock,
  //save
  fValidationHead_Client,
  fValidationDetail_Client,
  fLoad_Grid,
  fSaveHead,
  fSaveDetail,
  fDisplay,

  //Head functions
  fGetValidationDetail_Server,
  GetItemAttributes_Server,
  //Approve
  GetValidateHead_Server,

  //src doc
  Get_ToggleDropDown_Load,

  //grid history
  GetSalesHistory,
};
